import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InvalidFieldComponent } from 'src/app/shared/components';
import { ConfirmationModule } from 'src/app/shared/modules/confirmation/confirmation.module';
import { ConfirmationAllianceComponent } from './confirmation-alliance.component';

@NgModule({
    imports: [
        CommonModule,
        ConfirmationModule,
        ReactiveFormsModule,
        FormsModule,
        InvalidFieldComponent,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    declarations: [ConfirmationAllianceComponent],
})
export class ConfirmationAllianceModule {}
